import { createAsyncThunk } from '@reduxjs/toolkit';

export const setHeaderTitle = createAsyncThunk(
  'setHeaderTitle',
  async (
    data: { pageTitle: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return { pageTitle: data.pageTitle };
  }
);
